import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Button, ButtonGroup } from '@ohif/ui';

function ActionButtons({ onSaveClick, onExportClick, onCreateReportClick }) {
  const { t } = useTranslation('MeasurementTable');

  return (
    <React.Fragment>
      <ButtonGroup color="black" size="inherit">
        <Button className="px-2 py-2 text-base" onClick={onSaveClick}>
          {t('Save')}
        </Button>
        <Button className="px-2 py-2 text-base" onClick={onExportClick}>
          {t('Export CSV')}
        </Button>
        <Button className="px-2 py-2 text-base" onClick={onCreateReportClick}>
          {t('Create Report')}
        </Button>
      </ButtonGroup>
    </React.Fragment>
  );
}

ActionButtons.propTypes = {
  onSaveClick: PropTypes.func,
  onExportClick: PropTypes.func,
  onCreateReportClick: PropTypes.func,
};

ActionButtons.defaultProps = {
  onSaveClick: () => alert('Salvar'),
  onExportClick: () => alert('Export'),
  onCreateReportClick: () => alert('Create Report'),
};

export default ActionButtons;
